/**
 * Roles with full platform (admin CMS / back-office) access. The backend's
 * authorization policy (services/authorization/policy.ts) is the actual
 * enforcement; the frontend reads the same list only to decide which UI to
 * show (e.g. whether /admin routes render or redirect) — hiding UI is never
 * the security boundary.
 */
export const ADMIN_ROLES = ["platform_admin", "admin"] as const;

export function isAdminRole(role: string | null | undefined): boolean {
  return (ADMIN_ROLES as readonly string[]).includes(role ?? "");
}
